module.exports = __webpack_public_path__ + "img/W-AS3485030.3895fb0c.jpg";